import React from 'react';
import { Typography } from 'antd';
import { FormattedMessage } from 'react-intl';

import './chart-comment.less';
import messages from '../messages';

const { Text } = Typography;

const ChartComment = ({ text = '', editableConfig }) => (text || editableConfig ? (
  <div className="chart-comment">
    {editableConfig && !text && <FormattedMessage {...messages.addComment} />}
    <Text editable={editableConfig}>{text}</Text>
  </div>
) : null);

export default ChartComment;
